module.exports = __webpack_public_path__ + "images/icons/icon-truck-44b1517c.svg";